import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Input, InputNumber } from "antd";
import Notice from "Components/Notice";
import Ajax from "Pub/js/ajax";
import * as utilService from "./utilService";
import {
    showType,
    returnType,
    dataTypeObj,
    colorObj,
    mobileTitle,
    watermarktype,
} from "./utilService";
import {
    updateSelectCard,
    updateAreaList,
    toggleFormula,
    updateBatchSource,
    setFormulaInfo,
    updateSearchBox,
} from "Store/ZoneSetting/action";
import { handleFormula, checkAreaType, queryOrgAuthority } from "./events";
import MoneyModal from "./moneyModal";
import ReferModal from "./referModal";
import CustomModal from "./customModal";
import RelateMetaModal from "./relateMetaModal";
import DefaultValueModal from "./defaultValueModal";
import CusDocDefaultValueModal from "./CusDocDefaultValueModal";
import { langCheck, langZoneSetting, GetQuery } from "Pub/js/utils";
import SetTemplateRight from "./SetTemplate/setTemplateRight";
import { ControlTip } from "Components/ControlTip";
import platform from "Pub/js/platform";
import WatermarkModal from "./components/WatermarkModal/index";
import FiletypeModal from "./components/FiletypeModal/index";
import ReferFilterModal from "./components/ReferFilterModal";
const { NCDiv, NCCheckbox, NCSelect, NCMultiLangText, NCTabs, NCFormControl } = platform.base;
const { high, PubSub } = platform;
const { Refer, FormulaEditor } = high;
const Search = Input.Search;
const { TextArea } = Input;
const Option = NCSelect.NCOption;
const { NCTabPane } = NCTabs;
const inputStyle = { height: 28, width: "100%" };
//右边栏属性配置组件类
class MyRightSider extends Component {
    constructor(props) {
        super(props);

        this.urlRequestObj = GetQuery(this.props.location.search);
        this.pagecode = this.urlRequestObj.pcode;
        this.checkedAreaMap = new Map();
        this.isDevEnv = window.environmentmodel === 'development'; //判断是否开发环境
        this.state = {
            moneyModalVisibel: false,
            referModalVisibel: false,
            relateMetaModalVisibel: false,
            customModalVisibel: false,
            defaultValueModalVisibel: false,
            customDocDefaultModalVisibel: false, //自定义档案默认值弹框
            showformula: false,
            editformula: false,
            validateformula: false,
            watermark: false,
            filetype: false,
            referFilterModalVisible: false,
            isShowOrgRights: false,
            //2111：是否启用组织权限字段
            isShowGroupPower: false,
        };
    }

    componentDidMount() {
        //把nc-lightapp-front暴露给全局，供全局使用（艺轩）
        window["nc-lightapp-front"] = platform;

        //2111新增：是否开启组织权限
        this.pubsub = PubSub.subscribe('SELECT_CARD', (action, res) => {
            if (res !== this.state.isShowGroupPower) {
                if (res) {
                    this.setState({ isShowGroupPower: true });
                } else {
                    this.setState({ isShowGroupPower: false });
                }
            }
        });
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub);
    }

    componentWillReceiveProps(nextProps) {
        const { selectCard } = nextProps;

        if (!_.eq(this.props.selectCard, selectCard)) {
            const syncFields = ["issyncside", "issyncfold", "issynclist"];

            if (!Object.keys(selectCard).some(field => syncFields.includes(field))) {
                this.checkedAreaMap.clear();
                return false;
            }

            for (let key in selectCard) {
                if (syncFields.includes(key) && selectCard[key]) {
                    const relationArea = this.findAreaRelation(nextProps, key) || {};
                    if (relationArea.pk_area == undefined) { continue; }
                    this.checkedAreaMap.set(key, relationArea.pk_area);
                }
            }
        }
    }

    findAreaRelation = (nextProps, relationArea) => {
        const { selectCard, json, newAreaList } = nextProps;

        const currentArea = this.getArea(selectCard);

        let cNewAreaList = this.transferNewAreaList(newAreaList);

        switch (this.checkAreaType(currentArea)) {
            case "table":
                let sides = cNewAreaList.filter(item => item).find(item => item.pk_area == currentArea.pk_area);
                let sidesArea = sides && sides.sides && sides.sides.find(item => item.areastatus == "edit");
                let cardArea = sides && sides.sides && sides.sides.find(item => item.areastatus == "browse");

                switch (relationArea) {
                    case "issyncside":
                        return sidesArea;

                    case "issyncfold":
                        return cardArea;

                    default:
                        return null;
                }
            case "fold":
                let listArea = cNewAreaList.filter(item => item).find(item => item.code == currentArea.relationcode);

                let cardAreas = listArea && listArea.sides && listArea.sides.find(item => item.areastatus == "edit");

                switch (relationArea) {
                    case "issynclist":
                        return listArea;

                    case "issyncside":
                        return cardAreas;

                    default:
                        return null;
                }

            case "side":
                let listAreas = cNewAreaList.filter(item => item).find(item => item.code == currentArea.relationcode);

                let sidesAreas =
                    listAreas && listAreas.sides && listAreas.sides.find(item => item.areastatus == "browse");

                switch (relationArea) {
                    case "issynclist":
                        return listAreas;

                    case "issyncfold":
                        return sidesAreas;

                    default:
                        return null;
                }

            default:
                return null;
        }
    };

    /**
     * input数据变化，更新redux中selectCard对象
     * @param {String} value 设置的value值
     * @param {String} propertyKey 属性主键
     */
    changeValue = (value, propertyKey) => {
        let { selectCard } = this.props;
        if (_.isEmpty(selectCard)) {
            return;
        }
        selectCard = { ...selectCard };
        selectCard[propertyKey] = value;
        this.props.updateSelectCard(selectCard);
    };
    /**
     * input数据变化，更新redux中selectCard对象
     * @param {String} value 设置的value值
     * @param {String} propertyKey 属性主键
     */
    changeCheckboxValue = (value, property, checkedArea) => {
        let { selectCard } = this.props;
        if (_.isEmpty(selectCard)) {
            return;
        }
        selectCard = _.cloneDeep(selectCard);
        //如果设置的属性为visible，需要联动设置visibleposition属性
        if (property === "visible") {
            selectCard.visibleposition = "";
        }
        //实施态查询区勾选固定条件时需要调接口查预制模板是否勾选，根据接口返回值设置固定条件选中状态
        if (this.props.isImplement && property === "isfixedcondition" && selectCard.isfixedcondition == true) {
            let currentArea = this.getArea(selectCard);
            this.queryFixedCondition(
                {
                    pk_template: this.props.zoneFormData.pk_page_templet,
                    araecode: currentArea.code,
                    propcode: selectCard.code,
                },
                isfixedconditionFlag => {
                    selectCard[property] = value;
                    selectCard.isfixedcondition = isfixedconditionFlag;
                    this.asyncUpdataCardAndAreaList(selectCard, property);
                },
            );
        } else {
            selectCard[property] = value;
            this.asyncUpdataCardAndAreaList(selectCard, property);
        }

        const syncFields = ["issyncside", "issyncfold", "issynclist"];

        if (!syncFields.includes(property)) { return; }

        if (value && checkedArea) {
            this.checkedAreaMap.set(property, checkedArea.pk_area);
        } else {
            this.checkedAreaMap.delete(property);
        }
    };

    syncFields = areaList => {
        let { selectCard } = this.props;

        selectCard = _.cloneDeep(selectCard);

        // 不需要同步的属性
        const notSyncFields = [
            "pk_form_property",
            "pk_query_property",
            "areaid",
            "width",
            "position",
            "isnextrow",
            "issyncside",
            "issyncfold",
            "issynclist",
        ];

        if (this.checkedAreaMap.size == 0) { return false; }

        this.checkedAreaMap.forEach((checkedAreaCode, key, map) => {
            const undataAera = areaList.find(area => area.pk_area == checkedAreaCode);

            const { queryPropertyList } = undataAera;

            let isAddNode = true;

            queryPropertyList.map((syncField, index) => {
                if (syncField.code == selectCard.code) {
                    notSyncFields.forEach(notSyncField => {
                        if (selectCard.hasOwnProperty(notSyncField)) { delete selectCard[notSyncField]; }
                    });

                    queryPropertyList[index] = Object.assign(syncField, selectCard);

                    isAddNode = false;
                }
            });

            if (isAddNode) {
                notSyncFields.forEach(notSyncField => {
                    if (notSyncField == "areaid") {
                        selectCard.areaid = checkedAreaCode;
                    } else if (["pk_query_property", "pk_form_property"].includes(notSyncField)) {
                        selectCard[notSyncField] = "";
                    } else {
                        if (selectCard.hasOwnProperty(notSyncField)) { delete selectCard[notSyncField]; }
                    }
                });
                selectCard.position = queryPropertyList.length + 1;
                queryPropertyList.push(selectCard);
            }
        });
    };

    //通过字段查询区域
    getArea = (card, areaListSource) => {
        let result;
        areaListSource = areaListSource || this.props.areaList;
        areaListSource.forEach((val, index) => {
            val.queryPropertyList.forEach((v, i) => {
                if (card.areaid === v.areaid) {
                    result = val;
                    return;
                }
            });
        });
        return result;
    };
    //通过selectCard更新areaList对象 可以通过传入其他card修改其他card的字段值
    updateCardInArea = (selectCard = this.props.selectCard) => {
        let { areaList } = this.props;
        if (_.isEmpty(selectCard)) {
            return;
        }
        let targetAreaIndex = 0;
        let targetCardIndex = 0;
        areaList = _.cloneDeep(areaList);
        //遍历arealist，找到selectCard所在的区域
        _.forEach(areaList, (a, i) => {
            _.forEach(a.queryPropertyList, (q, index) => {
                if (q.areaid === selectCard.areaid && q.pk_query_property === selectCard.pk_query_property) {
                    targetAreaIndex = i;
                    targetCardIndex = index;
                    return false;
                }
            });
        });
        areaList[targetAreaIndex].queryPropertyList[targetCardIndex] = selectCard;
        this.props.updateAreaList(areaList, false, this.syncFields);
    };
    /**
     * 通过selectCard获取当前区域的所有卡片
     * @param {Array} queryPropertyList 当前区域的所有卡片
     */
    getCardListInAreaBySelectCard = () => {
        let { areaList, selectCard } = this.props;
        let targetAreaIndex = 0;
        _.forEach(areaList, (a, i) => {
            if (a.pk_area === selectCard.areaid) {
                targetAreaIndex = i;
                return false;
            }
        });
        return areaList[targetAreaIndex] ? areaList[targetAreaIndex].queryPropertyList : {};
    };
    //按回车键，input失去焦点
    onPressEnter = (value, property) => {
        this[`${property}input`].blur();
    };
    /**
     * 获得一个数字输入框组件
     * @param {String} placeholder 文本显示值
     * @param {String} property 属性主键
     * @return {} 数字输入框组件
     */
    getMyNumberInput = (placeholder, property) => {
        return (
            <div fieldid={property}>
                <InputNumber
                    min={1}
                    max={20}
                    value={this.props.selectCard[property]}
                    onChange={value => {
                        this.changeValue(value, property);
                    }}
                    onBlur={e => {
                        this.updateCardInArea();
                    }}
                    ref={input => (this[`${property}input`] = input)}
                    onPressEnter={e => {
                        this.onPressEnter(e.target.value, property);
                    }}
                />
            </div>
        );
    };
    /**
     * 获得一个文本输入框组件
     * @param {String} placeholder 文本显示值
     * @param {String} property 属性主键
     * @return {} 文本输入框组件
     */
    getMyInput(placeholder, property, notMeteData, maxlength = 200) {
        let disabled = false;
        //如果组件长度为null或者''时设置默认显示值为120
        if (property == "width") {
            if (this.props.selectCard[property] == null || this.props.selectCard[property] == "") {
                this.props.selectCard[property] = "120";
            }
        }
        //非元数据 metapath为空并且是编码
        if ((notMeteData == "" || notMeteData == null) && property == "code") {
            disabled = false;
        } else {
            //元数据
            //不是编码
            if (property != "code") {
                disabled = false;
            } else {
                //metapath不为空或者null 是编码
                disabled = true;
            }
        }
        //实施态查询区勾选固定条件时操作符编码、操作符名称、默认取值不可编辑
        if (this.props.isImplement && this.props.selectCard.isfixedcondition == true) {
            const disabledArr = ["opersign", "opersignname", "defaultvalue"];
            if (disabledArr.includes(property)) {
                disabled = true;
            }
        }
        return (
            <div fieldid={property}>
                <NCFormControl
                    isCheckChinese
                    maxlength={maxlength}
                    disabled={disabled}
                    style={inputStyle}
                    value={this.props.selectCard[property]}
                    onChange={e => {
                        if (property === 'maxlength') {
                            e = e.replace(/[^0-9]/g, '');
                        }
                        this.changeValue(e, property);
                    }}
                    onBlur={e => {
                        if (property == "label") {
                            this.props.updateSearchBox({ reset: true });
                        }
                        this.updateCardInArea();
                    }}
                    ref={input => (this[`${property}input`] = input)}
                    onPressEnter={e => {
                        this.onPressEnter(e, property);
                    }}
                />

                {/* <Input
                    disabled={disabled}
                    style={inputStyle}
                    value={this.props.selectCard[property]}
                    onChange={e => {
                        this.changeValue(e.target.value, property);
                    }}
                    onBlur={e => {
                        if (property == "label") {
                            this.props.updateSearchBox({ reset: true });
                        }
                        this.updateCardInArea();
                    }}
                    ref={input => (this[`${property}input`] = input)}
                    onPressEnter={e => {
                        this.onPressEnter(e.target.value, property);
                    }}
                /> */}
            </div>
        );
    }
    changeMultiLangText(value, propertyKey) {
        let { selectCard, multiOptions } = this.props;
        if (_.isEmpty(selectCard)) {
            return;
        }
        selectCard = { ...selectCard };
        multiOptions.forEach((opt, i) => {
            let k = `${propertyKey}${opt.index}`;
            selectCard[k] = value[k].value;
        });
        this.props.updateSelectCard(selectCard);
    }
    getMultiLangInput(placeholder, property, maxlength) {
        let { multiOptions, selectCard } = this.props;
        let itemValue = {};
        multiOptions.forEach((opt, i) => {
            let k = `${property}${opt.index}`;
            itemValue[k] = { value: selectCard[k] };
        });
        return (
            <div fieldid={property}>
                <NCMultiLangText
                    value={itemValue}
                    onChange={value => {
                        this.changeMultiLangText(value, property);
                    }}
                    onBlur={value => {
                        this.updateCardInArea();
                    }}
                    ref={input => (this[`${property}multilang`] = input)}
                    fieldid={property}
                    languageMeta={multiOptions}
                    attrcode={property}
                    maxlength={maxlength}
                    isCheckChinese
                />
            </div>
        );
    }
    /**
     * 不可修改字段disabled为true时的提示框
     * @returns Notice提示框
     */
    onPromptMsg = () => {
        return Notice({
            status: "warning",
            msg: langCheck("102202APP-000081", "pages", this.props.json),
        }); /* 国际化处理： 高级属性-不可修改编辑标志为是，该字段可编辑性不可修改*/
    }
    /**
     * 获得一个checkbox组件
     * @param {String} property 属性主键
     * @return {} checkbox组件
     */
    getMyCheckbox = (property, disabled = false, checkedArea) => {
        //实施态查询区勾选固定条件时使用不可编辑
        if (this.props.isImplement && this.props.selectCard.isfixedcondition == true) {
            if (property === "isuse") {
                disabled = true;
            }
        }
        //实施态的不可修改编辑性标志字段disabled为true
        if (this.props.isImplement && property === "editdisabled") {
            disabled = true;
        }

        //不可修改编辑性标志字段为true(勾选),则不可修改字段disabled为true
        if (this.props.selectCard.editdisabled === true) {
            if (property === 'disabled') {
                disabled = true;
            }
        }
        return (
            <div fieldid={property}>
                <NCCheckbox
                    disabled={disabled}
                    checked={Boolean(this.props.selectCard[property])}
                    onChange={val => {
                        this.changeCheckboxValue(val, property, checkedArea);
                    }}
                />
            </div>
        );
    };
    //原用做下拉选择的事件处理,现用来先更新selectCard后更新areaList
    handleSelectChange = (value, property) => {
        let { selectCard } = this.props;
        if (_.isEmpty(selectCard)) {
            return;
        }
        if (property === "mobiletitle") {
            //移动标题
            this.checkMobileTitleChange(value);
        }
        if (property === "itemtype") {
            if (value === "photo") {
                selectCard.uploadquantity = 10;
            } else if (value === "attachment") {
                selectCard.uploadquantity = "";
            }
        }
        selectCard = { ...selectCard };
        //做个优化，第一个参数可以传对象 一次可以改selectCard多个字段
        if (property === undefined) {
            selectCard = { ...selectCard, ...value };
        } else {
            //改变单个字段
            selectCard[property] = value;
            
            if (property === 'showtype') {
                selectCard['showfocus'] = value;
            }

            //进行业务相关的联动处理
            if (property === "datatype") {
                selectCard.dataval = "";
                selectCard.itemtype = utilService.getItemtypeByDatatype(selectCard.datatype);
                //小数或者金额
                if (value === "31" || value === "52") {
                    selectCard.dataval = "2,,";
                }
            }
        }
        this.asyncUpdataCardAndAreaList(selectCard, property);
    };
    //异步更新selectCard后更新areaList
    async asyncUpdataCardAndAreaList(selectCard, property) {
        await this.props.updateSelectCard(selectCard);
        this.updateCardInArea();
    }
    //获取下拉选择Dom
    getMySelect = (mySelectObj, property) => {
        // console.log(window.multiZoneSettingLang);
        const { selectCard } = this.props;
        let showValue = _.isEmpty(selectCard[property]) ? mySelectObj[0].value : selectCard[property];
        //显示类型如果值是0，显示时按2显示（0和2都是编码，0应该是历史数据）
        // if (property === "showtype" && selectCard[property] === "0") {
        //     showValue = "2";
        // }
        return (
            <div fieldid={property}>
                <NCSelect
                    showClear={false}
                    value={showValue}
                    onChange={value => {
                        this.handleSelectChange(value, property);
                    }}
                    // style={inputStyle}
                    fieldid={property}
                    multiple={property == "issupportphoto" ? true : false}
                // getPopupContainer={() => document.getElementById('fixSelect')}
                >
                    {(() => {
                        if (property === "color") {
                            return mySelectObj.map((c, index) => {
                                return (
                                    <Option key={index} value={c.value}>
                                        <span className='template-setting-color-select'>
                                            <span>{c.name}</span>
                                            <span className='color-select-color' style={{ backgroundColor: c.value }} />
                                        </span>
                                    </Option>
                                );
                            });
                        } else {
                            return mySelectObj.map((c, index) => {
                                return (
                                    <Option key={index} value={c.value}>
                                        {c.name}
                                    </Option>
                                );
                            });
                        }
                    })()}
                </NCSelect>
            </div>
        );
    };
    //判断是否为元数据
    getMetaType = selectCard => {
        if (selectCard.metapath) { return true; } // 是元数据
        return false; // 不是元数据 默认没选的情况是false
    };
    // 获取当前区域的类型
    getAreaType = () => {
        const { areaList, selectCard } = this.props;
        let result;
        _.forEach(areaList, (val, index) => {
            _.forEach(val.queryPropertyList, (v, i) => {
                if (selectCard.areaid === v.areaid) {
                    result = val.areatype;
                    return;
                }
            });
        });
        return result;
    };
    // 设置不同弹框的显示和隐藏
    setModalVisibel = (whichModalVisibel, val) => {
        this.setState({ [whichModalVisibel]: val });
    };
    //获得普通的search框组件
    getMySearch = (key, whichModalVisibel) => {
        const { selectCard, json } = this.props;
        let searchVal = selectCard[key];
        let disabled = false;
        //自定义档案显示参照名称
        if (selectCard.datatype === "57") {
            if (key === "dataval") {
                //类型设置
                searchVal = selectCard.refname;
            }
        }
        // 默认取值
        if (key === "defaultvalue" && (selectCard.datatype === "57" || selectCard.datatype === "204")) {
            let defaultValName = selectCard.defaultvalue && selectCard.defaultvalue.split("=");
            searchVal = defaultValName && defaultValName[0];
        }
        //参照类型值是-99显示成空
        if ((selectCard.datatype === "204" || selectCard.datatype === "57") && searchVal === "-99") {
            searchVal = "";
        }
        return (
            <div fieldid={key}>
                <Search
                    disabled={this.getPropertyDisabled(key)}
                    style={inputStyle}
                    value={searchVal}
                    onChange={() => { }}
                    onSearch={() => {
                        if (whichModalVisibel === "referFilterModalVisible" && (selectCard.pk_query_property.startsWith('newMetaData') ||
                            selectCard.pk_query_property.startsWith('newNotMetaData'))) {
                            this.setState({ [whichModalVisibel]: false });
                            Notice({
                                status: "warning",
                                msg: langCheck(
                                    "ZoneSetting-000349",
                                    "pages",
                                    json,
                                ), /* 国际化处理： 请先保存模板*/
                            });
                        } else {
                            this.setState({ [whichModalVisibel]: true });
                        }
                    }}

                />
            </div>
        );
    };
    //获得公式的search框组件
    getMyFormulaSearch = key => {
        const { selectCard, toggleFormula } = this.props;
        return (
            <div fieldid={key}>
                <Search
                    style={inputStyle}
                    value={selectCard[key]}
                    onChange={() => { }}
                    onSearch={() => {
                        handleFormula.call(this, selectCard);
                        toggleFormula([key], { visible: true, value: selectCard[key] });
                    }}
                />
            </div>
        );
    };
    //附件的弹窗(水印/文件类型)组件
    getMyModalSearch = key => {
        const { selectCard, toggleFormula } = this.props;
        return (
            <div fieldid={key}>
                <Search
                    className='attachmentSearch'
                    suffix={
                        <i
                            className='iconfont icon-danchuang'
                            onClick={() => {
                                handleFormula.call(this, selectCard);
                                toggleFormula([key], { visible: true, value: selectCard[key] });
                            }}
                        />
                    }
                    value={watermarktype(selectCard.watermarktype)}
                    style={inputStyle}
                    disabled={key == "filetype" && selectCard.datatype == "300" && selectCard.itemtype == "photo"}
                />
            </div>
        );
    };
    //切换移动标题校验
    checkMobileTitleChange = value => {
        let { selectCard } = this.props;
        const preMobiletitle = selectCard.mobiletitle; //暂存上一次移动标题值
        const areaCardList = this.getCardListInAreaBySelectCard();
        const langCheckFn = num => langCheck(`ZoneSetting-${num}`, "pages", this.props.json);
        if (value === "1" || value === "3") {
            //移动列表主标题/标签
            let targeCard = areaCardList.find(item => item.mobiletitle === value);
            const mobileTitleName = mobileTitle().find(item => item.value === value).name;
            if (targeCard && targeCard.pk_query_property !== selectCard.pk_query_property) {
                /* 国际化处理： XXX已设为列表标签，确定要替换当前字段为列表标签?（替换后XXX移动标题为空）*/
                const msg = `${targeCard.label}${langCheckFn("000253")}${mobileTitleName}${langCheckFn(
                    "000254",
                )}${mobileTitleName}？${langCheckFn("000255")}${targeCard.label}${langCheckFn("000256")}`;
                ControlTip({
                    status: "warning",
                    title: langCheck("ZoneSetting-000207", "pages", this.props.json) /* 国际化处理： 提示消息*/,
                    msg,
                    onOk: () => {
                        targeCard.mobiletitle = "0"; //清空原来字段值
                        this.updateCardInArea(targeCard);
                    },
                    onCancel: () => {
                        selectCard.mobiletitle = preMobiletitle; //替换成上一次值
                        this.asyncUpdataCardAndAreaList(selectCard);
                    },
                });
            }
        }
    };

    checkAreaType = currentArea => {
        const { isFold, isTable, isSide } = checkAreaType;

        if (isFold(currentArea)) { return "fold"; }

        if (isTable(currentArea)) { return "table"; }

        if (isSide(currentArea)) { return "side"; }
    };

    // 平铺 newAreaList
    transferNewAreaList = list => {
        let arr = [];

        list.forEach(item => {
            if (item) {
                arr.push(item);
                if (Array.isArray(item.tabs)) {
                    arr = arr.concat(item.tabs);
                }
            }
        });

        return arr;
    };

    renderSyncCheckbox = () => {
        const { selectCard, json, newAreaList } = this.props;

        const currentArea = this.getArea(selectCard);

        let cNewAreaList = this.transferNewAreaList(newAreaList);

        // 判断是否为新增区域
        if (currentArea && !currentArea.newArea) {
            switch (this.checkAreaType(currentArea)) {
                case "table":
                    let sides = cNewAreaList.filter(item => item).find(item => item.pk_area == currentArea.pk_area);
                    let sidesArea = sides && sides.sides && sides.sides.find(item => item.areastatus == "edit");
                    let cardArea = sides && sides.sides && sides.sides.find(item => item.areastatus == "browse");

                    return (
                        <React.Fragment>
                            {sidesArea && (
                                <React.Fragment>
                                    <li>{`${langCheck("ZoneSetting-000275", "pages", json)}${sidesArea.name}`}</li>
                                    {/* /* 国际化处理： 同步到侧拉*/}
                                    <li>{this.getMyCheckbox("issyncside", false, sidesArea)}</li>
                                </React.Fragment>
                            )}
                            {cardArea && (
                                <React.Fragment>
                                    <li>{`${langCheck("ZoneSetting-000275", "pages", json)}${cardArea.name}`}</li>
                                    {/* /* 国际化处理： 同步到卡片*/}
                                    <li>{this.getMyCheckbox("issyncfold", false, cardArea)}</li>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    );
                case "fold":
                    let listArea = cNewAreaList
                        .filter(item => item)
                        .find(item => item.code == currentArea.relationcode);

                    let cardAreas =
                        listArea && listArea.sides && listArea.sides.find(item => item.areastatus == "edit");

                    return (
                        <React.Fragment>
                            {listArea && (
                                <React.Fragment>
                                    <li>{`${langCheck("ZoneSetting-000275", "pages", json)}${listArea.name}`}</li>
                                    {/* /* 国际化处理： 同步到侧拉*/}
                                    <li>{this.getMyCheckbox("issynclist", false, listArea)}</li>
                                </React.Fragment>
                            )}
                            {cardAreas && (
                                <React.Fragment>
                                    <li>{`${langCheck("ZoneSetting-000275", "pages", json)}${cardAreas.name}`}</li>
                                    {/* /* 国际化处理： 同步到卡片*/}
                                    <li>{this.getMyCheckbox("issyncside", false, cardAreas)}</li>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    );
                case "side":
                    let listAreas = cNewAreaList
                        .filter(item => item)
                        .find(item => item.code == currentArea.relationcode);

                    let sidesAreas =
                        listAreas && listAreas.sides && listAreas.sides.find(item => item.areastatus == "browse");

                    return (
                        <React.Fragment>
                            {listAreas && (
                                <React.Fragment>
                                    <li>{`${langCheck("ZoneSetting-000275", "pages", json)}${listAreas.name}`}</li>
                                    {/* /* 国际化处理： 同步到侧拉*/}
                                    <li>{this.getMyCheckbox("issynclist", false, listAreas)}</li>
                                </React.Fragment>
                            )}
                            {sidesAreas && (
                                <React.Fragment>
                                    <li>{`${langCheck("ZoneSetting-000275", "pages", json)}${sidesAreas.name}`}</li>
                                    {/* /* 国际化处理： 同步到卡片*/}
                                    <li>{this.getMyCheckbox("issyncfold", false, sidesAreas)}</li>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    );

                default:
                    return null;
            }
        }
    };

    //1909新增字段
    renderCanEditFields = () => {
        const canEditFields = [
            { key: "#a", name: langCheck("ZoneSetting-000192", "pages", this.props.json) }, //能否修改属性
            { key: "#b", name: langCheck("ZoneSetting-000193", "pages", this.props.json) }, //能否修改可修改标志
            { key: "#c", name: langCheck("ZoneSetting-000194", "pages", this.props.json) }, //能否修改可见标志
            { key: "#d", name: langCheck("ZoneSetting-000195", "pages", this.props.json) }, //能否修改修订标志
        ];
        //实施态不显示这些字段
        if (this.props.isImplement) { return; }
        return canEditFields.map(item => [<li>{item.name}</li>, <li>{this.getMyCheckbox(item.key)}</li>]);
    };

    //渲染自定义档案默认值参照
    renderCustomDocRefer = () => {
        const { selectCard, json } = this.props;
        return (
            <li className="defaultvalue">
                {this.getMySearch("defaultvalue", "customDocDefaultModalVisibel")}
                <CusDocDefaultValueModal
                    docPk={selectCard.dataval}
                    refname={selectCard.refname}
                    isgrade={selectCard.isgrade}
                    handleSelectChange={this.handleSelectChange}
                    defaultvalue={selectCard.defaultvalue}
                    modalVisibel={this.state.customDocDefaultModalVisibel}
                    setModalVisibel={this.setModalVisibel}
                    json={json}
                    isMultiSelectedEnabled={selectCard.ismultiselectedenabled}
                />
            </li>
        );
    };

    //渲染数字类类型设置
    renderMoneyModal = () => {
        const { selectCard } = this.props;
        return (
            <li className="typesetting">
                {this.getMySearch("dataval", "moneyModalVisibel")}
                <MoneyModal
                    datatype={selectCard.datatype}
                    handleSelectChange={this.handleSelectChange}
                    initVal={selectCard.dataval}
                    modalVisibel={this.state.moneyModalVisibel}
                    setModalVisibel={this.setModalVisibel}
                />
            </li>
        );
    };

    //获取字段属性禁用状态
    getPropertyDisabled = property => {
        const { selectCard, isImplement } = this.props;
        let disabled = false;
        //默认取值
        if (property === "defaultvalue") {
            //实施态查询区勾选固定条件时默认取值不可编辑
            return isImplement && selectCard.isfixedcondition == true;
        }
        return disabled;
    };

    //查询预制模板固定条件是否勾选
    queryFixedCondition = (params, callback) => {
        Ajax({
            url: "/nccloud/platform/templet/checkfixedconditionaction.do",
            data: params,
            info: {
                name: langCheck("ZoneSetting-000017", "pages", this.props.json) /* 国际化处理： 单据模板设置*/,
                action: langCheck("ZoneSetting-000200", "pages", this.props.json), /* 国际化处理： 查询*/
            },
            success: res => {
                let { success, data } = res.data;
                if (success) {
                    callback(data);
                }
            },
        });
    };

    //2111新增:参照过滤字段
    renderReferFilter = () => {
        const { json, selectCard } = this.props;
        const { isShowOrgRights } = this.state;
        const areaCardList = this.getCardListInAreaBySelectCard();
        const currentArea = this.getArea(selectCard);

        return (
            isShowOrgRights
                ?
                <Fragment>
                    {/* 国际化处理： 权限组织*/}
                    {<li>{langCheck("ZoneSetting-000328", "pages", json)}</li>}
                    {<li>{this.getMySelect(utilService.permOrgItem(), "orgrights")}</li>}
                    {/* 国际化处理： 参照过滤*/}
                    <li className="refcondition">{langCheck("ZoneSetting-000331", "pages", json)}</li>
                    <li className="refcondition">
                        {this.getMySearch("refcondition", "referFilterModalVisible")}
                        {
                            this.state.referFilterModalVisible && (
                                <ReferFilterModal
                                    json={json}
                                    selectCard={selectCard}
                                    handleSelectChange={this.handleSelectChange}
                                    modalVisibel={this.state.referFilterModalVisible}
                                    cards={areaCardList}
                                    setModalVisibel={this.setModalVisibel}
                                    currentArea={currentArea}
                                />
                            )
                        }
                    </li>
                </Fragment>
                :
                <Fragment>
                    {/* 国际化处理： 参照过滤*/}
                    <li className="refcondition">{langCheck("ZoneSetting-000331", "pages", json)}</li>
                    <li className="refcondition">
                        {this.getMySearch("refcondition", "referFilterModalVisible")}
                        {
                            this.state.referFilterModalVisible && (
                                <ReferFilterModal
                                    json={json}
                                    selectCard={selectCard}
                                    handleSelectChange={this.handleSelectChange}
                                    modalVisibel={this.state.referFilterModalVisible}
                                    cards={areaCardList}
                                    setModalVisibel={this.setModalVisibel}
                                    currentArea={currentArea}
                                />
                            )
                        }
                    </li>
                </Fragment>
        );
    }

    //2111新增：查询区 参照名称改变Blur => 是否开启组织权限字段
    handleChangeRefName = value => {
        queryOrgAuthority.call(this, value, data => {
            this.setState({ isShowGroupPower: data });
        });
    }

    //2111新增：查询区 是否开启组织权限字段
    renderOrgAuthorities = () => {
        const { json } = this.props;
        const { isShowGroupPower } = this.state;
        if (isShowGroupPower) {
            return (
                <Fragment>
                    {/* 2111新增：是否启用组织权限字段 */}
                    <li className="isgrouppower">{langCheck("ZoneSetting-000340", "pages", json)}</li>
                    <li className="isgrouppower">{this.getMyCheckbox("isgrouppower")}</li>
                </Fragment>
            );
        }
    }

    //查询区渲染参照名称
    renderReferName = () => {
        const { selectCard, json } = this.props;
        //参照和自定义档案显示
        return (
            <Fragment>
                {/* /* 国际化处理： 参照名称*/}
                <li className="refname">{langCheck("ZoneSetting-000030", "pages", json)}</li>
                {selectCard.datatype === "204" ? ( //参照
                    <li className="refname">
                        {this.getMySearch("refname", "referModalVisibel")}
                        {this.renderReferModal(false)}
                    </li>
                ) : selectCard.datatype === "57" ? ( //自定义档案
                    <li className="refname">
                        {this.getMySearch("refname", "customModalVisibel")}
                        {this.renderCustomModal(false)}
                    </li>
                ) : (
                    <li className="refname">
                        {this.getMyInput(langCheck("ZoneSetting-000030", "pages", json), "refname", undefined, 200)}
                    </li>
                )}
            </Fragment>
        );
    }

    //渲染参照选择弹框
    renderReferModal = (isShowSetting = true) => {
        const { selectCard } = this.props;
        const refname = selectCard.refname !== '-99' ? selectCard.refname : '';
        return (
            <ReferModal
                handleSelectChange={this.handleSelectChange}
                dataval={selectCard.dataval}
                refname={refname}
                showfocus={selectCard.showfocus} //焦点离开后参照显示编码
                iscode={selectCard.iscode}
                onlyLeafCanSelect={selectCard.onlyLeafCanSelect} //是否可以选择非叶子节点
                isdatapowerenable={selectCard.isdatapowerenable} //是否启用数据权限
                isgrouppower={selectCard.isgrouppower} //是否启用组织权限 2111新增
                isShowGroupPower={this.state.isShowGroupPower} //是否显示启用组织权限
                modalVisibel={this.state.referModalVisibel}
                setModalVisibel={this.setModalVisibel}
                isShowSetting={isShowSetting}
                areatype={this.getAreaType()}
                onOk={({ isShowGroupPower }) => {
                    //查询区参照控制组织权限显隐
                    if (this.getAreaType() === "0") {
                        this.setState({ isShowGroupPower });
                    }
                }}
            />
        );
    }

    //渲染自定义档案弹框
    renderCustomModal = (isShowSetting = true) => {
        const { selectCard } = this.props;
        const refname = selectCard.refname !== '-99' ? selectCard.refname : '';
        return (
            <CustomModal
                handleSelectChange={this.handleSelectChange}
                initVal={selectCard.dataval}
                refname={refname}
                showfocus={selectCard.showfocus} //焦点离开后参照显示编码
                iscode={selectCard.iscode}
                onlyLeafCanSelect={selectCard.onlyLeafCanSelect} //是否可以选择非叶子节点
                isdatapowerenable={selectCard.isdatapowerenable} //是否启用数据权限
                modalVisibel={this.state.customModalVisibel}
                setModalVisibel={this.setModalVisibel}
                isShowSetting={isShowSetting}
            />
        );
    }

    //查询区，元数据属性
    getDom1 = () => {
        const { selectCard, json } = this.props;
        console.log("selectCard--", selectCard);
        let meteDate = selectCard.metapath; //区分元数据和非元数据
        // console.log('meteDate--', meteDate);
        return (
            <NCTabs defaultActiveKey="1" activeKey="1">
                <NCTabPane tab={langCheck("ZoneSetting-000075", "pages", json)} key='1'>
                    {/* /* 国际化处理： 显示属性*/}
                    <ul className='basic-property query-area'>
                        <li>{langCheck("ZoneSetting-000076", "pages", json)}</li>
                        {/* /* 国际化处理： 显示名称*/}
                        {/* <li>{this.getMyInput(langCheck("ZoneSetting-000076", "pages", json), "label")}</li> */}
                        {/* 云融合阶段，新设计器无法发布，所以根据玉洁需求将新设计器中多语文本配置移植到旧版设计器中 */}
                        <li>{this.getMultiLangInput(langCheck("ZoneSetting-000076", "pages", json), "label", 200)}</li>
                        {/* /* 国际化处理： 显示名称*/}
                        <li className="resid">{langCheck("ZoneSetting-000077", "pages", json)}</li>
                        {/* /* 国际化处理： 多语字段*/}
                        <li className="resid">{this.getMyInput(langCheck("ZoneSetting-000077", "pages", json), "resid", 50)}</li>
                        {/* /* 国际化处理： 多语字段*/}
                        <li>{langCheck("ZoneSetting-000078", "pages", json)}</li>
                        {/* /* 国际化处理： 数据类型*/}
                        {/* 元数据，禁止设置datatype属性，除了56自定义项*/}
                        {(() => {
                            if (selectCard.isdefined) {
                                //通过isdefined判断是否为自定义项，可以选择数据类型
                                return <li>{this.getMySelect(dataTypeObj(), "datatype")}</li>;
                            } else {
                                let showDataTypeName = utilService.getObjNameByDatatype(
                                    selectCard.datatype,
                                    dataTypeObj(),
                                );
                                showDataTypeName = showDataTypeName === "" ? selectCard.datatype : showDataTypeName;
                                return <li>{showDataTypeName}</li>;
                            }
                        })()}

                        {(() => {
                            return <li className="typesetting">{langCheck("ZoneSetting-000022", "pages", json)}</li>;
                        })()}
                        {/* /* 国际化处理： 类型设置*/}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举,32逻辑
                                return (
                                    <li className="typesetting">
                                        {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "showdataval")}
                                    </li>
                                );
                            } else {
                                return (
                                    <li className="typesetting">
                                        {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "dataval")}
                                    </li>
                                );
                            }
                        })()}

                        {/* 枚举隐藏项 */}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举,32逻辑
                                return (
                                    <li style={{ display: "none" }}>
                                        {langCheck("ZoneSetting-000022", "pages", json)}
                                    </li>
                                );
                            }
                        })()}
                        {/* /* 国际化处理： 类型设置*/}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举,32逻辑
                                return (
                                    <li style={{ display: "none" }}>
                                        {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "dataval")}
                                    </li>
                                );
                            }
                        })()}
                        {/* /* 国际化处理： 类型设置*/}

                        <li className="maxlength">{langCheck("ZoneSetting-000032", "pages", json)}</li>
                        {/* /* 国际化处理： 最大长度*/}
                        <li className="maxlength">{this.getMyInput(langCheck("ZoneSetting-000032", "pages", json), "maxlength", undefined, 10)}</li>
                        {/* /* 国际化处理： 最大长度*/}
                        {/* 只有开发环境显示非元数据条件 */}
                        <li>{this.isDevEnv && langCheck("ZoneSetting-000079", "pages", json)}</li>
                        {/* /* 国际化处理： 非元数据条件*/}
                        <li>{this.isDevEnv && this.getMyCheckbox("isnotmeta")}</li>
                        <li className="isuse">{langCheck("ZoneSetting-000080", "pages", json)}</li>
                        {/* /* 国际化处理： 使用*/}
                        <li className="isuse">{this.getMyCheckbox("isuse")}</li>
                        <li>{langCheck("ZoneSetting-000081", "pages", json)}</li>
                        {/* /* 国际化处理： 编码*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000081", "pages", json), "code", meteDate, 100)}</li>
                        {/* /* 国际化处理： 编码*/}
                        <li>{langCheck("ZoneSetting-000082", "pages", json)}</li>
                        {/* /* 国际化处理： 操作符编码*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000082", "pages", json), "opersign", undefined, 200)}</li>
                        {/* /* 国际化处理： 操作符编码*/}
                        <li>{langCheck("ZoneSetting-000083", "pages", json)}</li>
                        {/* /* 国际化处理： 操作符名称*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000083", "pages", json), "opersignname", undefined, 200)}</li>
                        {/* /* 国际化处理： 操作符名称*/}
                        <li className="defaultvalue">{langCheck("ZoneSetting-000084", "pages", json)}</li>
                        {/* /* 国际化处理： 默认取值*/}
                        {(() => {
                            if (selectCard.datatype === "204" && selectCard.refname !== "-99") {
                                return (
                                    <li className="defaultvalue">
                                        {this.getMySearch("defaultvalue", "defaultValueModalVisibel")}
                                        <DefaultValueModal
                                            areatype='0'
                                            refcode={selectCard.refcode}
                                            refname={selectCard.refname}
                                            isMultiSelectedEnabled={Boolean(selectCard.ismultiselectedenabled)}
                                            handleSelectChange={this.handleSelectChange}
                                            defaultvalue={selectCard.defaultvalue}
                                            modalVisibel={this.state.defaultValueModalVisibel}
                                            setModalVisibel={this.setModalVisibel}
                                            isUnit={this.props.status === "templateSetting-unit"} //业务单元进来
                                        />
                                    </li>
                                );
                            } else if (selectCard.datatype === "57" && selectCard.dataval) {
                                //自定义档案
                                return this.renderCustomDocRefer();
                            } else {
                                return (
                                    <li className="defaultvalue">
                                        {this.getMyInput(
                                            langCheck("ZoneSetting-000084", "pages", json) /* 国际化处理： 默认取值*/,
                                            "defaultvalue", undefined, 1000
                                        )}
                                    </li>
                                );
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000085", "pages", json)}</li>
                        {/* /* 国际化处理： 不可修改*/}

                        <li>
                            {this.getMyCheckbox(
                                "disabled",
                                this.props.isImplement && (selectCard["#a"] === true || selectCard["#b"] === true),
                            )}
                        </li>

                        <li>{langCheck("ZoneSetting-000086", "pages", json)}</li>
                        {/* /* 国际化处理： 默认显示*/}
                        <li>{this.getMyCheckbox("visible")}</li>
                        {/* 如果默认显示为true才显示*/}
                        {(() => {
                            if (selectCard.visible) {
                                return [
                                    <li className="visibleposition" key='visibleposition0'>
                                        {langCheck("ZoneSetting-000087", "pages", json)}
                                        {/* /* 国际化处理： 默认显示字段排序*/}
                                    </li>,
                                    <li className="visibleposition" key='visibleposition1'>
                                        {this.getMyInput(
                                            langCheck(
                                                "ZoneSetting-000087",
                                                "pages",
                                                json,
                                            ) /* 国际化处理： 默认显示字段排序*/,
                                            "visibleposition", undefined, 5000
                                        )}
                                    </li>,
                                ];
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000088", "pages", json)}</li>
                        {/* /* 国际化处理： 多选*/}
                        <li>{this.getMyCheckbox("ismultiselectedenabled")}</li>
                        <li className="isfixedcondition">{langCheck("ZoneSetting-000089", "pages", json)}</li>
                        {/* /* 国际化处理： 固定条件*/}
                        <li className="isfixedcondition">{this.getMyCheckbox("isfixedcondition")}</li>
                        <li>{langCheck("ZoneSetting-000090", "pages", json)}</li>
                        {/* /* 国际化处理： 必输条件*/}
                        <li>{this.getMyCheckbox("required")}</li>
                        <li className="isquerycondition">{langCheck("ZoneSetting-000091", "pages", json)}</li>
                        {/* /* 国际化处理： 查询条件*/}
                        <li className="isquerycondition">{this.getMyCheckbox("isquerycondition")}</li>
                        {/* /* 国际化处理： 参照名称*/}
                        {this.renderReferName()}
                        <li className="containlower">{langCheck("ZoneSetting-000092", "pages", json)}</li>
                        {/* /* 国际化处理： 参照包含下级*/}
                        <li className="containlower">{this.getMyCheckbox("containlower")}</li>
                        <li className="ischeck">{langCheck("ZoneSetting-000093", "pages", json)}</li>
                        {/* /* 国际化处理： 参照自动检查*/}
                        <li className="ischeck">{this.getMyCheckbox("ischeck")}</li>
                        <li className="isbeyondorg">{langCheck("ZoneSetting-000094", "pages", json)}</li>
                        {/* /* 国际化处理： 参照跨集团*/}
                        <li className="isbeyondorg">{this.getMyCheckbox("isbeyondorg")}</li>
                        <li className="usefunc">{langCheck("ZoneSetting-000095", "pages", json)}</li>
                        {/* /* 国际化处理： 使用系统函数*/}
                        <li className="usefunc">{this.getMyCheckbox("usefunc")}</li>
                        <li className="tablecode">{langCheck("ZoneSetting-000096", "pages", json)}</li>
                        {/* /* 国际化处理： 表编码*/}
                        <li className="tablecode">{this.getMyInput(langCheck("ZoneSetting-000096", "pages", json), "tablecode")}</li>
                        {/* /* 国际化处理： 表编码*/}
                        <li className="querytablename">{langCheck("ZoneSetting-000097", "pages", json)}</li>
                        {/* /* 国际化处理： 表名称*/}
                        <li className="querytablename">{this.getMyInput(langCheck("ZoneSetting-000097", "pages", json), "querytablename")}</li>
                        {/* /* 国际化处理： 表名称*/}
                        <li>{langCheck("ZoneSetting-000098", "pages", json)}</li>
                        {/* /* 国际化处理： 组件类型*/}
                        <li>
                            {this.getMySelect(utilService.getItemtypeObjByDatatype(selectCard.datatype), "itemtype")}
                        </li>
                        <li className="showtype">{langCheck("ZoneSetting-000099", "pages", json)}</li>
                        {/* /* 国际化处理： 显示类型*/}
                        <li className="showtype">{this.getMySelect(showType(), "showtype")}</li>
                        <li className="returntype">{langCheck("ZoneSetting-000100", "pages", json)}</li>
                        {/* /* 国际化处理： 返回类型*/}
                        <li className="returntype">{this.getMySelect(returnType(), "returntype")}</li>
                        {this.renderDefine()}
                        {/* 1909新增是否可修改字段 */}
                        {/* {this.renderCanEditFields()} */}
                        {/* 2111新增：是否开启组织权限字段 */}
                        {selectCard.datatype === '204' && this.renderOrgAuthorities()}
                        {/*  查询区参照显示过滤字段 */}
                        {selectCard.datatype === "204" && this.renderReferFilter()}
                    </ul>
                </NCTabPane>
            </NCTabs>
        );
    };
    //查询区，非元数据属性
    getDom2 = () => {
        const { selectCard, json } = this.props;
        let meteDate = selectCard.metapath; //区分元数据和非元数据
        // console.log('meteDate=', meteDate);
        console.log("selectCard=", selectCard);
        return (
            <NCTabs defaultActiveKey='1'>
                <NCTabPane tab={langCheck("ZoneSetting-000075", "pages", json)} key='1'>
                    {/* /* 国际化处理： 显示属性*/}
                    <ul className='basic-property query-area'>
                        <li>{langCheck("ZoneSetting-000076", "pages", json)}</li>
                        {/* /* 国际化处理： 显示名称*/}
                        {/* <li>{this.getMyInput(langCheck("ZoneSetting-000076", "pages", json), "label")}</li> */}
                        {/* 云融合阶段，新设计器无法发布，所以根据玉洁需求将新设计器中多语文本配置移植到旧版设计器中 */}
                        <li>{this.getMultiLangInput(langCheck("ZoneSetting-000076", "pages", json), "label", 200)}</li>
                        {/* /* 国际化处理： 显示名称*/}
                        <li className="resid">{langCheck("ZoneSetting-000077", "pages", json)}</li>
                        {/* /* 国际化处理： 多语字段*/}
                        <li className="resid">{this.getMyInput(langCheck("ZoneSetting-000077", "pages", json), "resid")}</li>
                        {/* /* 国际化处理： 多语字段*/}
                        {/* 只有开发环境显示非元数据条件 */}
                        <li>{this.isDevEnv && langCheck("ZoneSetting-000079", "pages", json)}</li>
                        {/* /* 国际化处理： 非元数据条件*/}
                        <li>{this.isDevEnv && this.getMyCheckbox("isnotmeta")}</li>
                        <li className="isuse">{langCheck("ZoneSetting-000080", "pages", json)}</li>
                        {/* /* 国际化处理： 使用*/}
                        <li className="isuse">{this.getMyCheckbox("isuse")}</li>
                        <li>{langCheck("ZoneSetting-000106", "pages", json)}</li>
                        {/* /* 国际化处理： 元数据属性*/}
                        <li>
                            {this.getMyInput(langCheck("ZoneSetting-000106", "pages", json), "metadataproperty")}
                            {/* /* 国际化处理： 元数据属性*/}
                        </li>
                        <li className="maxlength">{langCheck("ZoneSetting-000032", "pages", json)}</li>
                        {/* /* 国际化处理： 最大长度*/}
                        <li className="maxlength">{this.getMyInput(langCheck("ZoneSetting-000032", "pages", json), "maxlength", undefined, 10)}</li>
                        {/* /* 国际化处理： 最大长度*/}
                        <li>{langCheck("ZoneSetting-000081", "pages", json)}</li>
                        {/* /* 国际化处理： 编码*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000081", "pages", json), "code", meteDate, 100)}</li>
                        {/* /* 国际化处理： 编码*/}
                        <li>{langCheck("ZoneSetting-000082", "pages", json)}</li>
                        {/* /* 国际化处理： 操作符编码*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000082", "pages", json), "opersign")}</li>
                        {/* /* 国际化处理： 操作符编码*/}
                        <li>{langCheck("ZoneSetting-000083", "pages", json)}</li>
                        {/* /* 国际化处理： 操作符名称*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000083", "pages", json), "opersignname")}</li>
                        {/* /* 国际化处理： 操作符名称*/}
                        <li className="defaultvalue">{langCheck("ZoneSetting-000084", "pages", json)}</li>
                        {/* /* 国际化处理： 默认取值*/}
                        {(() => {
                            if (selectCard.datatype === "204" && selectCard.refname !== "-99") {
                                return (
                                    <li className="defaultvalue">
                                        {this.getMySearch("defaultvalue", "defaultValueModalVisibel")}
                                        <DefaultValueModal
                                            areatype='0'
                                            refcode={selectCard.refcode}
                                            refname={selectCard.refname}
                                            isMultiSelectedEnabled={Boolean(selectCard.ismultiselectedenabled)}
                                            handleSelectChange={this.handleSelectChange}
                                            defaultvalue={selectCard.defaultvalue}
                                            modalVisibel={this.state.defaultValueModalVisibel}
                                            setModalVisibel={this.setModalVisibel}
                                            isUnit={this.props.status === "templateSetting-unit"} //业务单元进来
                                        />
                                    </li>
                                );
                            } else if (selectCard.datatype === "57" && selectCard.dataval) {
                                //自定义档案
                                return this.renderCustomDocRefer();
                            } else {
                                return (
                                    <li className="defaultvalue">
                                        {this.getMyInput(
                                            langCheck("ZoneSetting-000084", "pages", json) /* 国际化处理： 默认取值*/,
                                            "defaultvalue",
                                        )}
                                    </li>
                                );
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000085", "pages", json)}</li>
                        {/* /* 国际化处理： 不可修改*/}
                        <li>
                            {this.getMyCheckbox(
                                "disabled",
                                this.props.isImplement && (selectCard["#a"] === true || selectCard["#b"] === true),
                            )}
                        </li>

                        <li>{langCheck("ZoneSetting-000086", "pages", json)}</li>
                        {/* /* 国际化处理： 默认显示*/}
                        <li>{this.getMyCheckbox("visible")}</li>
                        {/* 如果默认显示为true才显示*/}
                        {(() => {
                            if (selectCard.visible) {
                                return [
                                    <li className="visibleposition" key='visibleposition0'>
                                        {langCheck("ZoneSetting-000087", "pages", json)}
                                        {/* /* 国际化处理： 默认显示字段排序*/}
                                    </li>,
                                    <li className="visibleposition" key='visibleposition1'>
                                        {this.getMyInput(
                                            langCheck(
                                                "ZoneSetting-000087",
                                                "pages",
                                                json,
                                            ) /* 国际化处理： 默认显示字段排序*/,
                                            "visibleposition",
                                        )}
                                    </li>,
                                ];
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000088", "pages", json)}</li>
                        {/* /* 国际化处理： 多选*/}
                        <li>{this.getMyCheckbox("ismultiselectedenabled")}</li>
                        <li className="isfixedcondition">{langCheck("ZoneSetting-000089", "pages", json)}</li>
                        {/* /* 国际化处理： 固定条件*/}
                        <li className="isfixedcondition">{this.getMyCheckbox("isfixedcondition")}</li>
                        <li>{langCheck("ZoneSetting-000090", "pages", json)}</li>
                        {/* /* 国际化处理： 必输条件*/}
                        <li>{this.getMyCheckbox("required")}</li>
                        <li className="isquerycondition">{langCheck("ZoneSetting-000091", "pages", json)}</li>
                        {/* /* 国际化处理： 查询条件*/}
                        <li className="isquerycondition">{this.getMyCheckbox("isquerycondition")}</li>
                        {/* /* 国际化处理： 参照名称*/}
                        {this.renderReferName()}
                        <li className="containlower">{langCheck("ZoneSetting-000092", "pages", json)}</li>
                        {/* /* 国际化处理： 参照包含下级*/}
                        <li className="containlower">{this.getMyCheckbox("containlower")}</li>
                        <li className="ischeck">{langCheck("ZoneSetting-000093", "pages", json)}</li>
                        {/* /* 国际化处理： 参照自动检查*/}
                        <li className="ischeck">{this.getMyCheckbox("ischeck")}</li>
                        <li className="isbeyondorg">{langCheck("ZoneSetting-000094", "pages", json)}</li>
                        {/* /* 国际化处理： 参照跨集团*/}
                        <li className="isbeyondorg">{this.getMyCheckbox("isbeyondorg")}</li>
                        <li className="usefunc">{langCheck("ZoneSetting-000095", "pages", json)}</li>
                        {/* /* 国际化处理： 使用系统函数*/}
                        <li className="usefunc">{this.getMyCheckbox("usefunc")}</li>
                        <li className="tablecode">{langCheck("ZoneSetting-000096", "pages", json)}</li>
                        {/* /* 国际化处理： 表编码*/}
                        <li className="tablecode">{this.getMyInput(langCheck("ZoneSetting-000096", "pages", json), "tablecode")}</li>
                        {/* /* 国际化处理： 表编码*/}
                        <li className="querytablename">{langCheck("ZoneSetting-000097", "pages", json)}</li>
                        {/* /* 国际化处理： 表名称*/}
                        <li className="querytablename">{this.getMyInput(langCheck("ZoneSetting-000097", "pages", json), "querytablename")}</li>
                        {/* /* 国际化处理： 表名称*/}
                        <li className="showtype">{langCheck("ZoneSetting-000099", "pages", json)}</li>
                        {/* /* 国际化处理： 显示类型*/}
                        <li className="showtype">{this.getMySelect(showType(), "showtype")}</li>
                        <li className="returntype">{langCheck("ZoneSetting-000100", "pages", json)}</li>
                        {/* /* 国际化处理： 返回类型*/}
                        <li className="returntype">{this.getMySelect(returnType(), "returntype")}</li>
                        {/* 1909新增是否可修改字段 */}
                        {/* {this.renderCanEditFields()} */}
                    </ul>
                </NCTabPane>
                <NCTabPane tab={langCheck("ZoneSetting-000107", "pages", json)} key='2'>
                    {/* /* 国际化处理： 高级属性*/}
                    <ul className='basic-property query-area'>
                        <li>{langCheck("ZoneSetting-000078", "pages", json)}</li>
                        {/* /* 国际化处理： 数据类型*/}
                        <li>{this.getMySelect(dataTypeObj(), "datatype")}</li>

                        {(() => {
                            //203枚举、32逻辑、31小数、52金额、4整数显示类型设置
                            if (["203", "32", "31", "52", "4"].includes(selectCard.datatype)) {
                                return <li className="typesetting">{langCheck("ZoneSetting-000022", "pages", json)}</li>;
                            }
                        })()}
                        {/* /* 国际化处理： 类型设置*/}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举,32为逻辑
                                return (
                                    <li className="typesetting">
                                        {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "showdataval")}
                                    </li>
                                );
                            } else if (
                                selectCard.datatype === "31" ||
                                selectCard.datatype === "52" ||
                                selectCard.datatype === "4"
                            ) {
                                //31小数、4整数、52金额
                                return this.renderMoneyModal();
                            }
                            //2207查询区高级属性不显示类型设置
                            // else {
                            //     return (
                            //         <li>
                            //             {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "dataval")}
                            //         </li>
                            //     );
                            // }
                        })()}

                        {/* 枚举隐藏项 */}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举,32为逻辑
                                return (
                                    <li style={{ display: "none" }}>
                                        {langCheck("ZoneSetting-000022", "pages", json)}
                                    </li>
                                );
                            }
                        })()}
                        {/* /* 国际化处理： 类型设置*/}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举,32为逻辑
                                return (
                                    <li style={{ display: "none" }}>
                                        {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "dataval")}
                                    </li>
                                );
                            }
                        })()}

                        <li>{langCheck("ZoneSetting-000098", "pages", json)}</li>
                        {/* /* 国际化处理： 组件类型*/}
                        <li>
                            {this.getMySelect(utilService.getItemtypeObjByDatatype(selectCard.datatype), "itemtype")}
                        </li>
                        {this.renderDefine()}
                        {/* 2111新增：是否开启组织权限字段 */}
                        {selectCard.datatype === '204' && this.renderOrgAuthorities()}
                        {/*  查询区参照显示过滤字段 */}
                        {selectCard.datatype === "204" && this.renderReferFilter()}
                    </ul>
                </NCTabPane>
            </NCTabs>
        );
    };
    //非查询区，元数据属性||非元数据
    getDom3 = (areaType, isMetaData) => {
        const { selectCard, json, formula } = this.props;
        console.log("selectCard-------", selectCard);
        const isShowRelateMeta = selectCard.datatype === "204" ? "block" : "none"; //判断是否为参照
        const areaCardList = this.getCardListInAreaBySelectCard();
        let meteDate = selectCard.metapath; //区分元数据和非元数据
        // console.log('meteDate--', meteDate);
        let validateDataParm = { areacodes: formula.regionCode };
        // console.log("validateDataParm-----------", validateDataParm);
        return (
            <NCTabs defaultActiveKey='1'>
                <NCTabPane tab={langCheck("ZoneSetting-000075", "pages", json)} key='1'>
                    {/* /* 国际化处理： 显示属性*/}
                    <ul className='basic-property'>
                        <li>{langCheck("ZoneSetting-000076", "pages", json)}</li>
                        {/* /* 国际化处理： 显示名称*/}
                        {/* <li>{this.getMyInput(langCheck("ZoneSetting-000076", "pages", json), "label")}</li> */}
                        {/* 云融合阶段，新设计器无法发布，所以根据玉洁需求将新设计器中多语文本配置移植到旧版设计器中 */}
                        <li>{this.getMultiLangInput(langCheck("ZoneSetting-000076", "pages", json), "label", 200)}</li>
                        {/* /* 国际化处理： 显示名称*/}
                        <li>{langCheck("ZoneSetting-000077", "pages", json)}</li>
                        {/* /* 国际化处理： 多语字段*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000077", "pages", json), "resid", undefined, 50)}</li>
                        {/* /* 国际化处理： 多语字段*/}
                        <li>{langCheck("ZoneSetting-000081", "pages", json)}</li>
                        {/* /* 国际化处理： 编码*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000081", "pages", json), "code", meteDate, 100)}</li>
                        {/* /* 国际化处理： 编码*/}
                        {(() => {
                            if (!isMetaData) {
                                return [
                                    <li key='metadataproperty0'>
                                        {langCheck("ZoneSetting-000106", "pages", json)}
                                    </li> /* 国际化处理： 元数据属性*/,
                                    <li key='metadataproperty1'>
                                        {this.getMyInput(
                                            langCheck("ZoneSetting-000106", "pages", json) /* 国际化处理： 元数据属性*/,
                                            "metadataproperty",
                                            undefined, 50
                                        )}
                                    </li>,
                                ];
                            }
                        })()}
                        {(() => {
                            if (areaType === "1") {
                                //表单
                                return [
                                    <li key='colnum0'>
                                        {langCheck("ZoneSetting-000031", "pages", json)}
                                    </li> /* 国际化处理： 占用列数*/,
                                    <li key='colnum1'>
                                        {this.getMySelect(utilService.colnumObj, "colnum")}
                                        {/* /* 国际化处理： 占用列数*/}
                                    </li>,
                                ];
                            } else {
                                return [
                                    <li key='width0'>
                                        {langCheck("ZoneSetting-000108", "pages", json)}
                                    </li> /* 国际化处理： 组件长度*/,
                                    <li key='width1'>
                                        {this.getMyInput(langCheck("ZoneSetting-000108", "pages", json), "width", undefined, 5000)}
                                        {/* /* 国际化处理： 组件长度*/}
                                    </li>,
                                ];
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000032", "pages", json)}</li>
                        {/* /* 国际化处理： 最大长度*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000032", "pages", json), "maxlength", undefined, 10)}</li>
                        {/* /* 国际化处理： 最大长度*/}
                        <li>{langCheck("ZoneSetting-000109", "pages", json)}</li>
                        {/* /* 国际化处理： 可修订*/}
                        <li>
                            {this.getMyCheckbox(
                                "isrevise",
                                this.props.isImplement && (selectCard["#a"] === true || selectCard["#d"] === true),
                            )}
                        </li>
                        {(() => {
                            if (areaType === "1") {
                                //表单
                                return [
                                    <li key='nextrow0'>
                                        {langCheck("ZoneSetting-000110", "pages", json)}
                                    </li> /* 国际化处理： 另起一行*/,
                                    <li key='nextrow1'>{this.getMyCheckbox("isnextrow")}</li>,
                                ];
                            } else {
                                return [
                                    <li key='istotal0'>
                                        {langCheck("ZoneSetting-000111", "pages", json)}
                                    </li> /* 国际化处理： 合计*/,
                                    <li key='istotal1'>
                                        {this.getMyCheckbox(
                                            "istotal",
                                            this.props.isImplement && selectCard["#a"] === true,
                                        )}
                                    </li>,
                                ];
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000112", "pages", json)}</li>
                        {/* /* 国际化处理： 可见*/}
                        <li>
                            {this.getMyCheckbox(
                                "visible",
                                this.props.isImplement && (selectCard["#a"] === true || selectCard["#c"] === true),
                            )}
                        </li>
                        <li>{langCheck("ZoneSetting-000113", "pages", json)}</li>
                        {/* /* 国际化处理： 必输项*/}
                        <li>{this.getMyCheckbox("required", this.props.isImplement && selectCard["#a"] === true)}</li>
                        <li>{langCheck("ZoneSetting-000085", "pages", json)}</li>
                        {/* /* 国际化处理： 不可修改*/}

                        <li style={{ position: 'relative' }}>
                            {this.getMyCheckbox(
                                "disabled",
                                this.props.isImplement && (selectCard["#a"] === true || selectCard["#b"] === true),
                            )}
                            {selectCard.editdisabled &&
                                <div onClick={this.onPromptMsg} style={{ width: '22px', height: '14px', opacity: 0, position: 'absolute', left: '58px', top: '7px', zIndex: '3' }}></div>
                            }
                        </li>
                        {this.renderSyncCheckbox()}

                        <li>{langCheck("ZoneSetting-000084", "pages", json)}</li>
                        {/* /* 国际化处理： 默认取值*/}
                        {(() => {
                            if (
                                selectCard.datatype === "204" &&
                                !_.isUndefined(selectCard.refcode) &&
                                selectCard.refcode !== "" &&
                                selectCard.refcode !== null
                            ) {
                                //参照
                                return (
                                    <li>
                                        {this.getMySearch("defaultvalue", "defaultValueModalVisibel")}
                                        <DefaultValueModal
                                            refcode={selectCard.refcode}
                                            refname={selectCard.refname} //非查询区refname
                                            isMultiSelectedEnabled={Boolean(selectCard.ismultiselectedenabled)}
                                            handleSelectChange={this.handleSelectChange}
                                            defaultvalue={selectCard.defaultvalue}
                                            modalVisibel={this.state.defaultValueModalVisibel}
                                            setModalVisibel={this.setModalVisibel}
                                            isUnit={this.props.status === "templateSetting-unit"} //业务单元进来
                                        />
                                    </li>
                                );
                            } else if (selectCard.datatype === "57" && selectCard.dataval) {
                                //自定义档案
                                return this.renderCustomDocRefer();
                            } else if (selectCard.datatype === '30') { //大文本类型默认值显示textarea
                                return (
                                    <li>
                                        <TextArea
                                            rows={5}
                                            style={inputStyle}
                                            value={selectCard.defaultvalue}
                                            onChange={e => {
                                                this.changeValue(e.target.value, 'defaultvalue');
                                            }}
                                            onBlur={e => {
                                                this.updateCardInArea();
                                            }}
                                            ref={input => (this[`defaultvalueinput`] = input)}
                                        />
                                    </li>
                                );
                            } else {
                                return (
                                    <li>
                                        {this.getMyInput(
                                            langCheck("ZoneSetting-000084", "pages", json) /* 国际化处理： 默认取值*/,
                                            "defaultvalue", undefined, 1000
                                        )}
                                    </li>
                                );
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000114", "pages", json)}</li>
                        {/* /* 国际化处理： 默认系统变量*/}
                        <li>{this.getMySelect(utilService.defaultvarObj, "defaultvar")}</li>
                        <li>{langCheck("ZoneSetting-000115", "pages", json)}</li>
                        {/* /* 国际化处理： 显示颜色*/}
                        <li>{this.getMySelect(colorObj(), "color")}</li>
                        {/* 1909新增是否可修改字段 */}
                        {/* {this.renderCanEditFields()} */}
                        {/* 移动端模板增加字段 */}
                        {/* /* 国际化处理： 移动标题*/}
                        {this.props.ismobile &&
                            this.getAreaType() === "2" && [
                                <li>{langCheck("ZoneSetting-000233", "pages", json)}</li>,
                                <li>{this.getMySelect(mobileTitle(), "mobiletitle")}</li>,
                            ]}
                    </ul>
                </NCTabPane>
                <NCTabPane tab={langCheck("ZoneSetting-000107", "pages", json)} key='2'>
                    {/* /* 国际化处理： 高级属性*/}
                    <ul className='basic-property'>
                        <li>{langCheck("ZoneSetting-000078", "pages", json)}</li>
                        {/* /* 国际化处理： 数据类型*/}
                        {/* 元数据，禁止设置datatype属性，除了56自定义项*/}
                        {(() => {
                            if (isMetaData) {
                                if (selectCard.isdefined) {
                                    //通过isdefined判断是否为自定义项，可以选择数据类型
                                    return <li>{this.getMySelect(dataTypeObj(), "datatype")}</li>;
                                } else {
                                    let showDataTypeName = utilService.getObjNameByDatatype(
                                        selectCard.datatype,
                                        dataTypeObj(),
                                    );
                                    showDataTypeName = showDataTypeName === "" ? selectCard.datatype : showDataTypeName;
                                    return <li>{showDataTypeName}</li>;
                                }
                            } else {
                                return <li>{this.getMySelect(dataTypeObj(), "datatype")}</li>;
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000022", "pages", json)}</li>
                        {/* /* 国际化处理： 类型设置*/}
                        {(() => {
                            switch (true) {
                                case selectCard.datatype === "204": //参照
                                    return (
                                        <li>
                                            {this.getMySearch("refname", "referModalVisibel")}
                                            {this.renderReferModal()}
                                        </li>
                                    );
                                case selectCard.datatype === "31" ||
                                    selectCard.datatype === "52" ||
                                    selectCard.datatype === "4": //31小数、4整数、52金额
                                    return this.renderMoneyModal();
                                case selectCard.datatype === "57": //自定义档案
                                    return (
                                        <li>
                                            {this.getMySearch("dataval", "customModalVisibel")}
                                            {this.renderCustomModal()}
                                        </li>
                                    );
                                case selectCard.datatype === "203": //枚举
                                    return (
                                        <li>
                                            {this.getMyInput(
                                                langCheck(
                                                    "ZoneSetting-000022",
                                                    "pages",
                                                    json,
                                                ) /* 国际化处理： 类型设置*/,
                                                "showdataval", //枚举时显示'showdataval'为思康多语显示传值
                                                undefined, 2000
                                            )}
                                        </li>
                                    );
                                case selectCard.datatype === "32": //逻辑
                                    return (
                                        <li>
                                            {this.getMyInput(
                                                langCheck(
                                                    "ZoneSetting-000022",
                                                    "pages",
                                                    json,
                                                ) /* 国际化处理： 类型设置*/,
                                                "showdataval", //枚举时显示'showdataval'为思康多语显示传值
                                                undefined, 2000
                                            )}
                                        </li>
                                    );
                                default:
                                    return (
                                        <li>
                                            {this.getMyInput(
                                                langCheck(
                                                    "ZoneSetting-000022",
                                                    "pages",
                                                    json,
                                                ) /* 国际化处理： 类型设置*/,
                                                "dataval",
                                                undefined, 2000
                                            )}
                                        </li>
                                    );
                            }
                        })()}
                        {/* 隐藏显示值 */}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举，32为逻辑
                                return (
                                    <li style={{ display: "none" }}>
                                        {langCheck("ZoneSetting-000022", "pages", json)}
                                    </li>
                                );
                            }
                        })()}
                        {/* /* 国际化处理： 类型设置*/}
                        {(() => {
                            if (selectCard.datatype == "203" || selectCard.datatype == "32") {
                                //203为枚举，32为逻辑
                                return (
                                    <li style={{ display: "none" }}>
                                        {this.getMyInput(langCheck("ZoneSetting-000022", "pages", json), "dataval", undefined, 2000)}
                                    </li>
                                );
                            }
                        })()}
                        {(() => {
                            if (isMetaData) {
                                //通过isdefined判断是否为自定义项，可以选择数据类型
                                if (!selectCard.isdefined) {
                                    return (
                                        <li style={{ display: isShowRelateMeta }}>
                                            {langCheck("ZoneSetting-000071", "pages", json)}
                                            {/* /* 国际化处理： 元数据编辑关联项*/}
                                        </li>
                                    );
                                }
                            }
                        })()}
                        {(() => {
                            if (isMetaData) {
                                //通过isdefined判断是否为自定义项，可以选择数据类型
                                if (!selectCard.isdefined) {
                                    return (
                                        <li style={{ display: isShowRelateMeta }}>
                                            {this.getMySearch("relatemeta", "relateMetaModalVisibel")}
                                            <RelateMetaModal
                                                cards={areaCardList}
                                                handleSelectChange={this.handleSelectChange}
                                                initVal={selectCard.relatemeta}
                                                modalVisibel={this.state.relateMetaModalVisibel}
                                                setModalVisibel={this.setModalVisibel}
                                            />
                                        </li>
                                    );
                                }
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000098", "pages", json)}</li>
                        {/* /* 国际化处理： 组件类型*/}
                        <li>
                            {this.getMySelect(utilService.getItemtypeObjByDatatype(selectCard.datatype), "itemtype")}
                        </li>
                        {/* /*非元数据类型为附件显示*/}
                        {(() => {
                            if (this.props.ismobile && selectCard.datatype == "300") {
                                return (
                                    <Fragment>
                                        <li>{langCheck("ZoneSetting-000285", "pages", json)}</li>
                                        {/* /* 国际化处理： 启用拍照模式*/}
                                        <li>
                                            <li>{this.getMyCheckbox("issupportphoto")}</li>
                                        </li>
                                        {/* /* 国际化处理： 启用拍照模式*/}
                                        <li>{langCheck("ZoneSetting-000286", "pages", json)}</li>
                                        {/* /* 国际化处理： 上传张数*/}
                                        <li>
                                            {this.getMyInput(
                                                langCheck("ZoneSetting-000286", "pages", json),
                                                "uploadquantity", undefined, 2000
                                            )}
                                        </li>
                                        {/* /* 国际化处理： 上传张数*/}
                                        <li>{langCheck("ZoneSetting-000287", "pages", json)}</li>
                                        {/* /* 国际化处理： 水印*/}
                                        <li>{this.getMyModalSearch("watermark")}</li>
                                        {/* /* 暂时先隐藏文件类型*/}
                                        {/*<li>{langCheck("ZoneSetting-000288", "pages", json)}</li>*/}
                                        {/* /* 国际化处理： 文件类型*/}
                                        {/* <li>{this.getMyFormulaSearch("filetype")}</li>*/}
                                    </Fragment>
                                );
                            }
                        })()}
                        <li>{langCheck("ZoneSetting-000116", "pages", json)}</li>
                        {/* /* 国际化处理： 显示公式*/}
                        <li>{this.getMyFormulaSearch("showformula")}</li>
                        <li>{langCheck("ZoneSetting-000117", "pages", json)}</li>
                        {/* /* 国际化处理： 编辑公式*/}
                        <li>{this.getMyFormulaSearch("editformula")}</li>
                        <li>{langCheck("ZoneSetting-000118", "pages", json)}</li>
                        {/* /* 国际化处理： 验证公式*/}
                        <li>{this.getMyFormulaSearch("validateformula")}</li>
                        <li>{langCheck("ZoneSetting-000119", "pages", json)}</li>
                        {/* /* 国际化处理： 超链接*/}
                        <li>{this.getMyCheckbox("hyperlinkflag")}</li>
                        <li>{langCheck("ZoneSetting-000339", "pages", json)}</li>
                        {/* 国际化处理： 不可修改编辑性标志(2111新增) */}
                        <li>{this.getMyCheckbox("editdisabled")}</li>
                        <li>{langCheck("ZoneSetting-000120", "pages", json)}</li>
                        {/* /* 国际化处理： 元数据访问路径*/}
                        <li title={selectCard.metapath} className='metapath'>
                            {selectCard.metapath}
                        </li>
                        <li>{langCheck("ZoneSetting-000101", "pages", json)}</li>
                        {/* /* 国际化处理： 自定义1*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000101", "pages", json), "define1", undefined, 50)}</li>
                        {/* /* 国际化处理： 自定义1*/}
                        <li>{langCheck("ZoneSetting-000102", "pages", json)}</li>
                        {/* /* 国际化处理： 自定义2*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000102", "pages", json), "define2", undefined, 50)}</li>
                        {/* /* 国际化处理： 自定义2*/}
                        <li>{langCheck("ZoneSetting-000103", "pages", json)}</li>
                        {/* /* 国际化处理： 自定义3*/}
                        <li>{this.getMyInput(langCheck("ZoneSetting-000103", "pages", json), "define3", undefined, 50)}</li>
                        {/* /* 国际化处理： 自定义3*/}
                        {/* 参照显示过滤字段 */}
                        {selectCard.datatype === "204" && this.renderReferFilter()}
                    </ul>
                </NCTabPane>
            </NCTabs>
        );
    };

    renderDefine = () => {
        const { json, ismobile } = this.props;
        // if (ismobile) { return null }
        return <React.Fragment>
            <li>{langCheck("ZoneSetting-000101", "pages", json)}</li>
            {/* /* 国际化处理： 自定义1*/}
            <li>{this.getMyInput(langCheck("ZoneSetting-000101", "pages", json), "define1", undefined, 50)}</li>
            {/* /* 国际化处理： 自定义1*/}
            <li>{langCheck("ZoneSetting-000102", "pages", json)}</li>
            {/* /* 国际化处理： 自定义2*/}
            <li>{this.getMyInput(langCheck("ZoneSetting-000102", "pages", json), "define2", undefined, 50)}</li>
            {/* /* 国际化处理： 自定义2*/}
            <li>{langCheck("ZoneSetting-000103", "pages", json)}</li>
            {/* /* 国际化处理： 自定义3*/}
            <li>{this.getMyInput(langCheck("ZoneSetting-000103", "pages", json), "define3", undefined, 50)}</li>
            {/* /* 国际化处理： 自定义3*/}
            <li>{langCheck("ZoneSetting-000104", "pages", json)}</li>
            {/* /* 国际化处理： 自定义4*/}
            <li>{this.getMyInput(langCheck("ZoneSetting-000104", "pages", json), "define4", undefined, 50)}</li>
            {/* /* 国际化处理： 自定义4*/}
            <li>{langCheck("ZoneSetting-000105", "pages", json)}</li>
            {/* /* 国际化处理： 自定义5*/}
            <li>{this.getMyInput(langCheck("ZoneSetting-000105", "pages", json), "define5", undefined, 50)}</li>
            {/* /* 国际化处理： 自定义5*/}
        </React.Fragment>;
    }

    //批量设置修改单元格数据
    onCellChange = (index, property) => {
        return value => {
            let { batchSource } = this.props;
            batchSource = _.cloneDeep(batchSource);
            let target = batchSource[index];
            if (target) {
                target[property] = value;
                this.props.updateBatchSource(batchSource);
            }
        };
    };

    //公式编辑器确定事件
    handleFormulaOkClick = (val, formulaType) => {
        const { index, code } = this.props.currentBatchCell;
        //批量设置中设置公式
        if (_.isEmpty(this.props.selectCard)) {
            this.onCellChange(index, code)(val);
        } else {
            //高级属性中设置公式
            this.handleSelectChange(val, formulaType);
        }
        this.props.toggleFormula(formulaType, false);
    };

    render() {
        const { selectCard, areaList, formula, selectedArea, json, ismobile } = this.props;
        // console.log('areaList======', areaList);

        // 1 判断是否是元数据 2 判断所属的类型是否是查询区  默认是 不是元数据 不是查询区
        // 处理公式编辑器
        let result_div;
        if (_.isEmpty(selectedArea) && _.isEmpty(selectCard)) {
            result_div = null;
        } else if (!_.isEmpty(selectedArea)) {
            result_div = <SetTemplateRight json={this.props.json} multiOptions={this.props.multiOptions} />;
        } else {
            let isMetaData = this.getMetaType(selectCard);
            let areaType = this.getAreaType();
            let isSearch = areaType === "0";
            if (isSearch) {
                //不区分显示属性和高级属性
                if (isMetaData) {
                    //元数据中metapath 和datatype和类型设置 为只读
                    result_div = this.getDom1();
                } else {
                    //非元数据metapath为空且只读，datatype和类型设置 为可以设置
                    result_div = this.getDom2();
                }
            } else {
                //非查询区，元数据||非元数据
                result_div = this.getDom3(areaType, isMetaData);
            }
        }

        return (
            <NCDiv
                className='template-setting-right-sider template-setting-sider'
                fieldid='right'
                areaCode={NCDiv.config.Area}>
                <div className={`sider-content ${ismobile ? 'is-mobile' : ''}`}>
                    <div className='sider-tab'>{result_div}</div>
                </div>
                {/* 显示公式弹框 */}
                {formula.showformula.visible && (
                    <FormulaEditor
                        value={formula.showformula.value}
                        isValidateOnOK={true}
                        validateUrl={"/nccloud/platform/formula/check.do"}
                        validateData={{ areacodes: formula.regionCode, pagecode: this.pagecode }}
                        formulaUrl={`/nccloud/platform/formula/control.do`}
                        treeParam={{
                            pk_billtype: "CM02",
                            bizmodelStyle: "fip",
                            classid: "",
                        }}
                        noShowAttr={[langCheck("ZoneSetting-000106", "pages", json)]} /* 国际化处理： 元数据属性*/
                        show={formula.showformula.visible}
                        onHide={() => {
                            this.props.toggleFormula("showformula", false);
                        }}
                        attrConfig={formula.tab}
                        onOk={val => this.handleFormulaOkClick(val, "showformula")}
                        onCancel={() => {
                            this.props.toggleFormula("showformula", false);
                        }}
                    />
                )}
                {/* 编辑公式弹框 */}
                {formula.editformula.visible && (
                    <FormulaEditor
                        value={formula.editformula.value}
                        isValidateOnOK={true}
                        validateUrl={"/nccloud/platform/formula/check.do"}
                        validateData={{ areacodes: formula.regionCode, pagecode: this.pagecode }}
                        formulaUrl={`/nccloud/platform/formula/control.do`}
                        noShowAttr={[langCheck("ZoneSetting-000106", "pages", json)]} /* 国际化处理： 元数据属性*/
                        show={formula.editformula.visible}
                        onHide={() => {
                            this.props.toggleFormula("editformula", false);
                        }}
                        attrConfig={formula.tab}
                        onOk={val => this.handleFormulaOkClick(val, "editformula")}
                        onCancel={() => {
                            this.props.toggleFormula("editformula", false);
                        }}
                    />
                )}
                {/* 验证公式弹框 */}
                {formula.validateformula.visible && (
                    <FormulaEditor
                        value={formula.validateformula.value}
                        isValidateOnOK={true}
                        validateUrl={"/nccloud/platform/formula/check.do"}
                        validateData={{ areacodes: formula.regionCode, pagecode: this.pagecode }}
                        formulaUrl={`/nccloud/platform/formula/control.do`}
                        noShowAttr={[langCheck("ZoneSetting-000106", "pages", json)]} /* 国际化处理： 元数据属性*/
                        show={formula.validateformula.visible}
                        onHide={() => {
                            this.props.toggleFormula("validateformula", false);
                        }}
                        attrConfig={formula.tab}
                        onOk={val => this.handleFormulaOkClick(val, "validateformula")}
                        onCancel={() => {
                            this.props.toggleFormula("validateformula", false);
                        }}
                    />
                )}
                {/* 水印 */}
                {formula.watermark.visible && (
                    <WatermarkModal
                        handleSelectCardChange={selectCard => {
                            this.asyncUpdataCardAndAreaList(selectCard);
                        }}
                        toggleFormula={this.props.toggleFormula}
                        visible={formula.watermark.visible}
                        json={json}
                    />
                )}
                {/* 文件类型 */}
                {formula.filetype.visible && (
                    <FiletypeModal
                        customHeader={langCheck("ZoneSetting-000288", "pages", json)} /* 国际化处理： 文件类型*/
                        visible={formula.filetype.visible}
                        onOk={() => {
                            this.props.toggleFormula("filetype", false);
                        }}
                        onCancel={() => {
                            this.props.toggleFormula("filetype", false);
                        }}
                        json={json}
                    />
                )}
            </NCDiv>
        );
    }
}
export default connect(
    state => ({
        areaList: state.zoneSettingData.areaList,
        selectCard: state.zoneSettingData.selectCard,
        formula: state.zoneSettingData.formula,
        selectedArea: state.zoneSettingData.selectedArea,
        currentBatchCell: state.zoneSettingData.currentBatchCell,
        batchSource: state.zoneSettingData.batchSource,
        zoneFormData: state.zoneSettingData.zoneFormData,
        isImplement: state.zoneSettingData.isImplement,
        newAreaList: state.zoneSettingData.newAreaList,
        ismobile: state.zoneSettingData.ismobile,
    }),
    {
        updateAreaList,
        updateSelectCard,
        updateBatchSource,
        toggleFormula,
        setFormulaInfo,
        updateSearchBox,
    },
)(withRouter(MyRightSider));
